import { FormControlLabelProps, RadioProps } from '@mui/material';
import RadioGroup, { RadioGroupProps } from '@mui/material/RadioGroup';
import React from 'react'
import { Controller } from 'react-hook-form';
import RadioButton from './ui/RadioButton';
import { RhfOption } from './types/RhfOption';
import { RhfProps } from './types/RhfProps';
import { RhfStyleProps } from './types/RhfStyleProps';

type Props = RhfProps & RhfStyleProps & {
    row?: boolean;
    options?: RhfOption[] | string[] | object[];
    children?: React.ReactNode;

    displayMember?: string;
    valueMember?: string;

    groupProps?: RadioGroupProps;
    markProps?: RadioProps;// RadioProps - 統一的 Radio 屬性樣式
    formControlLabelProps?: FormControlLabelProps
};

const RhfRadioGroup = ({ rhf, name, defaultValue, rules, // RhfProps
    sx, className, style,// RhfStyleProps

    row, options, children,
    displayMember, valueMember,

    groupProps,
    markProps,
    formControlLabelProps,
    ...restProps
}: Props) => {

    // if (row == null) {
    //     row = true;// 預設橫向排列
    // }

    if (displayMember == null) {
        displayMember = "label";
    }

    if (valueMember == null) {
        valueMember = "value";
    }

    return (
        <Controller
            control={rhf?.control}
            name={name}
            defaultValue={(defaultValue == null ? "" : String(defaultValue))}
            rules={rules}

            render={({ field }) => { // 等同於: render={({ field: { onChange, onBlur, value, ref } }) => (                                                

                return (
                    <RadioGroup {...groupProps} row={row}
                        sx={sx} className={className} style={style}

                        {...field} // 等同於: onChange={onChange} onBlur={onBlur} value={value} ref={ref}                    
                    >
                        {options == null ? <></> : options.map((option: any) => {

                            if (typeof (option) === "string") {
                                option = { value: option, label: option }
                            }
                            const val = String(option[valueMember as string]);
                            const lbl = option[displayMember as string];
                            const key = `${name}.${val}`;

                            return (
                                <RadioButton // 注意! 這裡使用 uncontrolled 元件
                                    key={key}
                                    value={val} label={lbl}
                                    markProps={markProps}
                                    formControlLabelProps={formControlLabelProps}
                                />
                            )
                        })}
                        {children}
                    </RadioGroup>
                );
            }}
        />
    )
}

export default RhfRadioGroup

// controlled 元件 如果要做 OneHot 模式
// <RhfRadioButton rhf={rhf}
//     key={key} name={rdo_name}
//     value={val} label={lbl}
//     markProps={markProps}
//     formControlLabelProps={formControlLabelProps}
// />